var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverride(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41002 14.8256C8.20937 15.6238 10.3525 15.5805 12.1877 14.5209C15.2368 12.7605 16.2815 8.86161 14.5211 5.8125L14.3336 5.48774M3.47894 12.1876C1.71853 9.13847 2.76324 5.23958 5.81235 3.47918C7.64759 2.4196 9.79068 2.37624 11.59 3.17452M1.87012 12.2503L3.91916 12.7994L4.46819 10.7503M13.532 7.24936L14.0811 5.20032L16.1301 5.74936",
    stroke: "#92D36A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverride);
export default __webpack_public_path__ + "static/media/override.1fff6c07c41fbc80ed622e6bbf440a09.svg";
export { ForwardRef as ReactComponent };